/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tab, Tabs, useMediaQuery } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import theme from "../Themes/Theme";
import styles from "../Styles/dashboard.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { localUrlEnum } from "../Utils/UrlEnum";
import { productSettings } from "../Utils/AutocompleteUtils";
import Attributes from "../Components/ProductSettings/Attributes/Attributes";
import Categories from "../Components/ProductSettings/Categories/Categories";
import Types from "../Components/ProductSettings/Types/Types";

export default function ProductSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [value, setValue] = useState(0);

  /**
   *
   */
  useEffect(() => {
    const search: any = location.search.split("?");
    search.forEach((value: any) => {
      if (value !== "") {
        const params = value.split("&");
        const values = params[0].split("=");
        setValueFromLocation(values[1]);
      }
    });
  }, [location]);

  /**
   *
   * @param newValue
   */
  function setValueFromLocation(newValue: string) {
    switch (newValue) {
      case productSettings.attributes:
        setValue(0);
        break;
      case productSettings.categories:
        setValue(1);
        break;
      case productSettings.types:
        setValue(2);
        break;
      default:
        setValue(0);
        break;
    }
  }
  /**
   *
   * @param event
   * @param newValue
   */
  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    switch (newValue) {
      case 0:
        navigate(
          `${localUrlEnum.productSettings}?type=${productSettings.attributes}`
        );
        break;
      case 1:
        navigate(
          `${localUrlEnum.productSettings}?type=${productSettings.categories}`
        );
        break;
      case 2:
        navigate(
          `${localUrlEnum.productSettings}?type=${productSettings.types}`
        );
        break;
      default:
        navigate(
          `${localUrlEnum.productSettings}?type=${productSettings.attributes}`
        );
        break;
    }
  }

  /**
   *
   */
  function showInformationForTabs() {
    switch (value) {
      case 0:
        return <Attributes />;
      case 1:
        return <Categories />;
      case 2:
        return <Types />;
      default:
        return <Attributes />;
    }
  }

  /**
   *
   * @param tabValue
   * @returns
   */
  function getTabStyle(tabValue: number) {
    return {
      backgroundColor:
        value === tabValue
          ? theme.palette.secondary.main
          : theme.palette.cancel?.main,
      color: value === tabValue ? "white" : "#9c9b9b",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      marginRight: "1px",
    };
  }

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <Tabs
        value={value}
        onChange={handleChangeValue}
        TabIndicatorProps={{
          style: {
            backgroundColor: theme.palette.secondary.main,
          },
        }}
        style={{ width: "100%" }}
      >
        <Tab label={Vocabulary.attributes} style={getTabStyle(0)} />
        <Tab label={Vocabulary.categories} style={getTabStyle(1)} />
        <Tab label={Vocabulary.types} style={getTabStyle(2)} />
      </Tabs>
      <> {showInformationForTabs()}</>
    </div>
  );
}
